import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Counter, Services, WhyUs, FAQs } from '../../../sections';
import { faqsContent } from '../../../constants';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About />
        <Counter />
        <Services />
        <WhyUs />
        <FAQs faqsContent={faqsContent} /> {/* FAQs Section */}

      </section>

    </>
  );
}

export default AboutUs;